/*
 * TableOfAttachments.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 11 2023 mys Company
 */

import { localization } from '../../config/localize/localizable'
import deleteSVG from '../../assets/icons/delete.svg'
import { useFileHooks } from '../../modules/file/hooks/useFileHooks'
import { toast } from 'react-hot-toast'
import { useEffect, useState } from 'react'
import imagePlaceHolder from '../../assets/images/imageplaceholder.png'
import audioPlaceHolder from '../../assets/images/audioPlaceholder.png'
import videoPlaceHolder from '../../assets/images/videoPlaceholder.png'
import { BASE_URL } from '../../config/constant/constants'

const TableOfAttachments = ({ items }) => {
    //
    // MARK: VARIABLE
    const fileService = useFileHooks()
    const [deletedItems, setDeletedItems] = useState([])

    //
    // MARK: METHODS

    useEffect(() => {}, [deletedItems])

    const handleFileDelete = (e, model) => {
        fileService.deleted(model.id, {
            onSuccess: async (response) => {
                setDeletedItems([...deletedItems, model])
                toast.success(response.data.messages[0])
            },
        })
    }

    return (
        <>
            <table className="w-full p-2 bg-white text-center  rounded">
                <thead className="h-10  bg-table-header text-xs rounded">
                    <tr>
                        <th>{localization.number}</th>
                        <th>{localization.title}</th>
                        <th>{localization.description}</th>
                        <th>{localization.date}</th>
                        <th>{localization.actions}</th>
                    </tr>
                </thead>
                <tbody>
                    {items &&
                        items
                            ?.sort((a, b) => {
                                return b.registerDate.localeCompare(a.registerDate)
                            })
                            .map((item, index) => {
                                return (
                                    <tr
                                        className={`text-sm p-8 h-12 hover:bg-orange-50 border-b border-blue-100 ${index % 2 === 0 ? '' : 'bg-gray-50'} ${
                                            deletedItems.filter((x) => x.id === item.id).length > 0 ? 'hidden' : ''
                                        }`}
                                        key={index}
                                    >
                                        <td>
                                            <img
                                                src={item.mimeType.includes('image') ? BASE_URL + 'v1/files/' + item?.id + '/s' : item.mimeType.includes('audio') ? audioPlaceHolder : videoPlaceHolder}
                                                alt={item.title}
                                                className="h-10 rounded m-1 shadow-sm "
                                                onError={(e) => {
                                                    e.target.src = imagePlaceHolder
                                                }}
                                            />
                                        </td>
                                        <td>{item.title}</td>
                                        <td>{(item.description ?? '').length > 75 ? item.description.substring(0, 75) + '...' : item.description}</td>
                                        <td>{new Date(item.registerDate).toLocaleDateString('fa-IR')}</td>
                                        <td>
                                            <img
                                                className="w-7 h-7 inline-block mr-2 hover:bg-gray-200 rounded p-1"
                                                src={deleteSVG}
                                                alt={localization.delete}
                                                title={localization.delete}
                                                onClick={(e) => handleFileDelete(e, item)}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                </tbody>
            </table>
        </>
    )
}

export default TableOfAttachments
